import React, { useEffect, useState } from 'react'
import Modal from '../common/modal'
import { Item } from '../common/snippets'
import { Box, Tab, Tabs } from '@mui/material'
import BranchRecharge from './BranchRecharge'
import PartyRecharge from './partyRecharge'
import { getBranchListAndCityList, GetRechargePaymentModesListAll, updateAlertError } from '../../store/common/common_action'
import { isEmpty } from '../common/helper'
import { connect } from 'react-redux'
import { useAtom } from 'jotai'
import { outStandingAmountAtom } from '../common/jotaiState/commonStateAtoms'
import { RAJESH_TRANSPORT } from '../../helper/companyIdhardcode'
import { useTranslation } from '../../i18n/I18nProvider'

const RechargeReqModal = ({
  data,
  updateModal,
  updateAlertError,
  getBranchListAndCityList,
  GetRechargePaymentModesListAll,
  companySettings,
}) => {
  const { translations } = useTranslation()
  const rh = translations?.recharge || {}
  const { headText, common } = data
  const { loginData } = common
  const { intCompanyID } = loginData
  const [cargoBalance, setCargoBalance] = useState('')
  const [outStandingAmount] = useAtom(outStandingAmountAtom)

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '24px',
  }

  useEffect(() => {
    if (loginData && !isEmpty(loginData)) {
      const obj = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: -1,
      }
      getBranchListAndCityList(obj)
        .then((res) => {
          if (res.status === 'Success') {
            setCargoBalance(res?.Data?.Table?.[0]?.CargoBalance)
          } else {
            updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          }
        })
        .catch((err) => {
          updateAlertError({ show: true, msg: err, nextId: '' })
        })
      GetRechargePaymentModesListAll()
    }
  }, [loginData])
  const BranchPageTab = [rh.branchRecharge || 'BRANCH RECHARGE', rh.partyRecharge || 'PARTY RECHARGE']
  const [selectedTab, setSelectedTab] = useState(0)
  const getRechargeReqContent = (typeId, label) => {
    switch (typeId) {
      case 0:
        return (
          <BranchRecharge loginData={loginData} cargoBalance={cargoBalance} updateModal={updateModal} companySettings={companySettings} />
        )
      case 1:
        return (
          <PartyRecharge loginData={loginData} cargoBalance={cargoBalance} updateModal={updateModal} companySettings={companySettings} />
        )
      default:
        return label
    }
  }
  return (
    <Modal
      headTxt={headText}
      width={'92%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Box className="BranchPageTabContainer scrollBlue" sx={{ maxHeight: '85vh' }}>
        <Item sx={{ paddingTop: 0, paddingX: 0 }}>
          <Box
            style={{
              display: outStandingAmount || intCompanyID === RAJESH_TRANSPORT ? 'none' : undefined,
            }}
            sx={{
              paddingX: '15px',
              borderBottom: 1,
              borderColor: 'divider',
              backgroundColor: '#F2F9FF !important',
              position: 'sticky',
              top: 0,
              zIndex: 6,
            }}
          >
            <Tabs
              value={selectedTab}
              variant="scrollable"
              aria-label="bsic tabs example"
              sx={{
                minHeight: 'unset',
                alignItems: 'center',
                zIndex: 100,
              }}
              onChange={(e, newValue) => {
                setSelectedTab(newValue)
              }}
            >
              {BranchPageTab.map((reqType, index) => (
                <Tab key={`sender_${index}`} label={reqType} {...RechargeReqTabID(index)} />
              ))}
            </Tabs>
          </Box>
          {BranchPageTab.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== index}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
            >
              {selectedTab === index && <Box>{getRechargeReqContent(index, reqType)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getBranchListAndCityList,
  updateAlertError,
  GetRechargePaymentModesListAll,
}
export default connect(mapStateToProps, mapDispatchToProps)(RechargeReqModal)
// export default RechargeReqModal

const RechargeReqTabID = (index) => {
  return {
    id: `RechargeReq-tab-${index}`,
    'aria-controls': `RechargeReq-tabpanel-${index}`,
  }
}
